import { render, staticRenderFns } from "./ContactCard.vue?vue&type=template&id=9a105e28&"
import script from "./ContactCard.vue?vue&type=script&lang=ts&"
export * from "./ContactCard.vue?vue&type=script&lang=ts&"
import style0 from "./ContactCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports